<template>
    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 !w-full text-center lg:w-full">
        <NuxtImg src="/svg/recommended-badge.svg" class="w-12 h-12 lg:w-16 lg:h-16 mb-4 animate-pulse mx-auto" />
        <h5 class="text-title-sm lg:text-title-md font-bold text-gray-100 mb-1 whitespace-nowrap w-full">
            {{ $t("dashboardComponents_uploader_uploadingPhoto") }}
            <Icon name="svg-spinners:3-dots-scale" size="24px" />
        </h5>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
